// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
/**
 *
 * @export
 * @interface ResourceTemporalRange
 */
export interface ResourceTemporalRange {
  /**
   *
   */
  gte: Date;
  /**
   *
   */
  lte?: Date | null;
}

/**
 * Check if a given object implements the ResourceTemporalRange interface.
 */
export function instanceOfResourceTemporalRange(value: object): value is ResourceTemporalRange {
  if (!("gte" in value) || value["gte"] === undefined) return false;
  return true;
}

export function ResourceTemporalRangeFromJSON(json: any): ResourceTemporalRange {
  return ResourceTemporalRangeFromJSONTyped(json, false);
}

export function ResourceTemporalRangeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ResourceTemporalRange {
  if (json == null) {
    return json;
  }
  return {
    gte: json["gte"] == null ? json["gte"] : parseDateTime(json["gte"]),
    lte:
      json["lte"] === undefined
        ? undefined
        : json["lte"] === null
        ? null
        : parseDateTime(json["lte"]),
  };
}

export function ResourceTemporalRangeToJSON(json: any): ResourceTemporalRange {
  return ResourceTemporalRangeToJSONTyped(json, false);
}

export function ResourceTemporalRangeToJSONTyped(
  value?: ResourceTemporalRange | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    gte: value["gte"] == null ? value["gte"] : serializeDateTime(value["gte"]),
    lte: value["lte"] == null ? value["lte"] : serializeDateTime(value["lte"]),
  };
}
